import "./debug/silenceConsole";
import ReactDOM from "react-dom/client";
import "./index.css";
import { App } from "./App";
import { reportWebVitals } from "./reportWebVitals";
import init from "target_wasm";
import { ErrorPage } from "components/ErrorPage";
import { createLogger } from "./debug/DebugingLogger";
import { openPaymentLinkIfPresent } from "./lib/paddle";
import React from "react";
const log = createLogger("Index");

// Paddle's dunning emails land on `?_ptxn=`; Paddle.js only opens the card
// form if it is initialized when the page loads.
openPaymentLinkIfPresent();
const requiredEnvVariables = [
  "VITE_APP_DATA_SERVICE",
  "VITE_APP_STORAGE_SERVICE",
  "VITE_APP_BASE_URL",
  "VITE_APP_WEBSOCKET_URL",
  "VITE_APP_GOOGLE_ROOT_URL",
  "VITE_APP_GOOGLE_CLIENT_ID",
  "VITE_APP_SCOPE_GOOGLE_API",
];
function validateEnvVariables(): boolean {
  const missingVariables = requiredEnvVariables.filter(
    (varName) => !import.meta.env[varName],
  );

  if (missingVariables.length > 0) {
    log.error(
      `Missing required environment variables: ${missingVariables.join(", ")}`,
    );
    return false;
  }

  log.info("All required environment variables are present.");
  return true;
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

if (!validateEnvVariables()) {
  log.error(
    "Critical error: Missing environment variables. The application will not start.",
  );
  root.render(<ErrorPage />);
} else {
  init()
    .then(() => {
      root.render(<App />);
    })
    .catch((error) => {
      log.error("Failed to initialize wasm:", error);
      root.render(<ErrorPage />);
    });
}

reportWebVitals();
